import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { AgeDescriptionDialog } from "./AgeDescriptionDialog";
import { AgeCategoriesSection } from "./AgeCategoriesSection";

interface AgeLevelSectionProps {
  age: string;
  categories: Array<{ name: string }>;
  openCategory: string | null;
  onCategoryClick: (categoryId: string) => void;
  getLevelsForAgeAndCategory: (age: string, category: string) => Array<{ name: string; difficulty: string; title?: string; id: string }>;
  onLevelClick: (age: string, category: string, level: string) => void;
}

export const AgeLevelSection = ({
  age,
  categories,
  openCategory,
  onCategoryClick,
  getLevelsForAgeAndCategory,
  onLevelClick,
}: AgeLevelSectionProps) => {
  return (
    <AccordionItem 
      value={age}
      className="border rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow"
    >
      <AccordionTrigger className="px-6 py-4 hover:no-underline">
        <div className="flex items-center gap-2">
          <span className="text-xl font-heading font-semibold">
            {age}
          </span>
          <AgeDescriptionDialog age={age} />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-6 pb-4">
        <AgeCategoriesSection
          age={age}
          categories={categories}
          openCategory={openCategory}
          onCategoryClick={onCategoryClick}
          getLevelsForAgeAndCategory={getLevelsForAgeAndCategory}
          onLevelClick={onLevelClick}
        />
      </AccordionContent>
    </AccordionItem>
  );
};